import { TasksTypes } from './actionTypes';

export const getTasks = (data: any) => ({
  type: TasksTypes.GET_TASKS,
  payload: data,
});

export const getTasksSuccess = (tasks: any) => {
  return {
    type: TasksTypes.GET_TASKS_SUCCESS,
    payload: tasks,
  };
};

export const getTasksFail = (error: any) => ({
  type: TasksTypes.GET_TASKS_FAIL,
  payload: error,
});

export const getTasksDetail = (permissionId: number) => ({
  type: TasksTypes.GET_TASKS_DETAIL,
  permissionId,
});

export const getTasksDetailSuccess = (tasks: any) => ({
  type: TasksTypes.GET_TASKS_DETAIL_SUCCESS,
  payload: tasks,
});

export const getTasksDetailFail = (error: any) => ({
  type: TasksTypes.GET_TASKS_DETAIL_FAIL,
  payload: error,
});

export const addTasks = (tasksAdd: any) => {
  return {
    type: TasksTypes.ADD_TASKS,
    payload: { tasksAdd },
  };
};

export const addTasksSuccess = (tasksAdd: any) => {
  return {
    type: TasksTypes.ADD_TASKS_SUCCESS,
    payload: tasksAdd,
  };
};

export const addTasksFail = (error: any) => {
  return {
    type: TasksTypes.ADD_TASKS_FAIL,
    payload: error,
  };
};

export const deleteTasks = (data: any) => {
  return {
    type: TasksTypes.DELETE_TASKS,
    payload: data,
  };
};

export const deleteTasksSuccess = (payload: any) => {
  return {
    type: TasksTypes.DELETE_TASKS_SUCCESS,
    payload,
  };
};

export const deleteTasksFail = (error: any) => {
  return {
    type: TasksTypes.DELETE_TASKS_FAIL,
    payload: error,
  };
};

export const updateTasks = (tasks: any) => {
  return {
    type: TasksTypes.UPDATE_TASKS,
    payload: { tasks },
  };
};

export const updateTasksSuccess = (tasks: any) => {
  return {
    type: TasksTypes.UPDATE_TASKS_SUCCESS,
    payload: tasks,
  };
};

export const updateTasksFail = (error: any) => {
  return {
    type: TasksTypes.UPDATE_TASKS_FAIL,
    payload: error,
  };
};
